import { render, staticRenderFns } from "./TransferPayment.vue?vue&type=template&id=26c3b19c&"
import script from "./TransferPayment.vue?vue&type=script&lang=js&"
export * from "./TransferPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports